module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-base-info"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "brand",
    on: {
      "click": function($event) {
        return _vm.jump(("beastapp://brand/" + (_vm.product.brand.id) + "?title=" + (_vm.product.brand.name)))
      }
    }
  }, [_vm._v(_vm._s(_vm.product.brand && _vm.product.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "prices"
  }, [(_vm.product.mainStationFirst) ? _c('div', {
    staticClass: "mainStationFirst"
  }, [_vm._v("首单价: ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "real",
    class: {
      'firstColor': _vm.product.mainStationFirst
    }
  }, [_c('div', {
    staticClass: "price",
    class: {
      rush: _vm.product._rush.state
    }
  }, [_c('price', {
    attrs: {
      "data": _vm.product.format_price.price.min
    }
  })], 1), _vm._v(" "), (_vm.product.format_price.price.max && _vm.product.format_price.price.max > _vm.product.format_price.price.min) ? _c('div', {
    staticClass: "price",
    class: {
      rush: _vm.product._rush.state
    }
  }, [_vm._v("\n          - "), _c('price', {
    attrs: {
      "data": _vm.product.format_price.price.max
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "raw"
  }, [(_vm.product.format_price.price.min != _vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "rawPrice"
  }, [(_vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.format_price.rawPrice.min
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product.format_price.rawPrice.max && _vm.product.format_price.rawPrice.max > _vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "price"
  }, [_vm._v("\n            - "), _c('price', {
    attrs: {
      "data": _vm.product.format_price.rawPrice.max
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isNewTag && !_vm.product.mainStationFirst) ? _c('div', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")]) : _vm._e(), _vm._v(" "), (_vm.product.spvPriceTag && _vm.product.spvPriceTag.length) ? _c('div', {
    staticClass: "price-tag-wrap"
  }, [_vm._l((_vm.product.spvPriceTag), function(priceTag) {
    return _c('div', {
      staticClass: "price-tag"
    }, [_c('span', {
      staticClass: "price-tag-text",
      style: ({
        color: priceTag.textColor,
        borderColor: priceTag.edgeColor
      })
    }, [_vm._v(_vm._s(priceTag.text))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "price-tag-more"
  }, [_c('span', {
    staticClass: "price-more",
    on: {
      "click": _vm.showPriceTag
    }
  }, [_vm._v("···")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product.spvStockWarn) ? _c('div', {
    staticClass: "stocks-warn"
  }, [_vm._v(_vm._s(_vm.product.spvStockWarn || ''))]) : _vm._e(), _vm._v(" "), (_vm.myFundPrice.length === 1) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + "元" + _vm._s(_vm.refundsName))]) : (_vm.myFundPrice.length && _vm.myFundPrice[0] == _vm.myFundPrice[_vm.myFundPrice.length - 1]) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + "元" + _vm._s(_vm.refundsName))]) : (_vm.myFundPrice.length > 0) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + " ~ " + _vm._s(_vm._f("formatPrice")(this.fundPrice[_vm.myFundPrice.length - 1])) + "元" + _vm._s(_vm.refundsName))]) : _vm._e(), _vm._v(" "), (_vm.product.downPayment) ? _c('div', {
    staticClass: "downpay-infos"
  }, [_c('div', {
    staticClass: "downpay-price-box"
  }, [_c('div', {
    staticClass: "downpay-label"
  }, [_vm._v("预付定金价：")]), _vm._v(" "), (_vm.product.downPayment.range[0] !== _vm.product.downPayment.range[1]) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[0]
    }
  }), _vm._v("\n            - "), _c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[1]
    }
  })], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[0]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "downpay-desc-box"
  }, [_c('div', {
    staticClass: "downpay-desc"
  }, [_c('div', {
    staticClass: "desc-box"
  }, [_vm._l((_vm.product.downPayment.details), function(item, index) {
    return _c('div', {
      key: item.spvId,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("定金 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-price"
    }, [_c('price', {
      attrs: {
        "data": item.price
      }
    })], 1) : (!_vm.product.downPayment.priceSingle) ? _c('span', {
      staticClass: "desc-price"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item.price
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.product.downPayment.details), function(item, index) {
    return (_vm.product.downPayment.deductionFlag) ? _c('div', {
      key: item.spvId,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("可抵 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-deduction"
    }, [_c('price', {
      attrs: {
        "data": item.deduction
      }
    })], 1) : (!_vm.product.downPayment.deductionSingle) ? _c('span', {
      staticClass: "desc-deduction"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item.deduction
      }
    })], 1) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "desc-time"
  }, [_vm._v("| " + _vm._s(_vm.product.downPayment.downTimeStr))])], 2), _vm._v(" "), _c('div', {
    staticClass: "desc-box",
    class: {
      'none': _vm.product.downPayment.tips ? false : true
    }
  }, [_vm._l((_vm.finalDetails), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("尾款 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-price"
    }, [_c('price', {
      attrs: {
        "data": item
      }
    })], 1) : (!_vm.product.downPayment.finalSingle) ? _c('span', {
      staticClass: "desc-price"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "desc-time"
  }, [_vm._v("| " + _vm._s(_vm.product.downPayment.finalTimeStr))])], 2), _vm._v(" "), (_vm.product.downPayment.tips) ? _c('div', {
    staticClass: "desc-tips"
  }, _vm._l((_vm.product.downPayment.tips), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "desc-tip"
    }, [_c('span', [_vm._v("*")]), _vm._v(" " + _vm._s(item))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "downpay-rule",
    on: {
      "click": _vm.downpayRuleAction
    }
  })]), _vm._v(" "), (_vm.product.waterMarkImage && _vm.product.waterMarkImage.length && _vm.product.waterMarkImage[0].indexOf('homegift.jpg') !== -1) ? _c('div', {
    staticClass: "downpay-image",
    on: {
      "click": _vm.downpayImageAction
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.product.waterMarkImage[0]
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.product.priceForecast) ? _c('div', {
    staticClass: "price-forecasts"
  }, [_c('div', {
    staticClass: "forecast-details"
  }, [_c('span', {
    staticClass: "forecast-details-name"
  }, [_vm._v(_vm._s(_vm.product.priceForecast.name))]), _vm._v(" "), _c('span', {
    staticClass: "forecast-details-price"
  }, [_vm._v(_vm._s(_vm.product.priceForecast._price))]), _vm._v(" "), _c('span', {
    staticClass: "forecast-details-date"
  }, [_c('i', [_vm._v(" | ")]), _vm._v(" " + _vm._s(_vm.product.priceForecast._since) + " " + _vm._s((_vm.product._rush.notAll && _vm.product._rush.state) ? '(商品部分规格不支持抢购)' : ''))])])]) : _vm._e(), _vm._v(" "), (_vm.product.presell) ? _c('div', {
    staticClass: "presell"
  }, [_vm._v("\n    " + _vm._s(_vm.product.presell && _vm.product.presell.content) + " "), (_vm.product._rush.notAll && _vm.product._rush.state) ? void 0 : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product.customPrintTemplate == 6) ? _c('div', {
    staticClass: "custom-card"
  }, [_vm._v("本商品享受"), _c('span', [_vm._v("「刻字服务」")]), _vm._v("，请在下单时选择")]) : (_vm.product.canCustomCard) ? _c('div', {
    staticClass: "custom-card"
  }, [_vm._v("该商品支持定制"), _c('span', [_vm._v("专属标签")]), _vm._v("，请在下单时选择")]) : _vm._e(), _vm._v(" "), (_vm.product.furniture || (_vm.product.needVerifyAddress && !_vm.product.monthSend)) ? _c('div', {
    staticClass: "p-info-tip"
  }, [_c('div', {
    staticClass: "tips"
  }, _vm._l((_vm.product.tips), function(tip) {
    return _c('div', {
      staticClass: "tip"
    }, [(tip.presentation) ? _c('div', {
      staticClass: "address-tip-title"
    }, [_vm._v(_vm._s(tip.presentation))]) : _vm._e(), _vm._v(" "), (tip.content) ? _c('p', [_vm._v(_vm._s(tip.title)), _c('span', {
      staticClass: "content"
    }, [_vm._v(_vm._s(tip.content))])]) : _vm._e()])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354bd270"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/product-info.vue
// module id = 1006
// module chunks = 2